module.exports = __webpack_public_path__ + "static/media/dam2.ab3efddc.jpg";